import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../services/redux/hook';
import { toggleTheme } from '../services/redux/slices/theme/theme';

const useDarkMode = () => {

    const darkMode = useAppSelector((state) => state.theme.darkMode);
    const dispatch = useAppDispatch();

    // Updating the body class whenever darkMode changes
    useEffect(() => {
        
        if (darkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [darkMode]);

    const toggleDarkModeHandler = () => {
        dispatch(toggleTheme());
    };

    return { darkMode, toggleDarkMode: toggleDarkModeHandler };
};

export default useDarkMode;
